// tienda/MapMockup.jsx
// Uses Miraflores static map image from /public
// Keeps animated delivery route overlay

import React from "react";
import { motion } from "framer-motion";
import { MapPin, Clock } from "lucide-react";
import { brand } from "../shared/brand";

export function MapMockup() {
  return (
    <div className="absolute inset-0 overflow-hidden rounded-tr-2xl rounded-br-2xl">

      {/* STATIC MAP IMAGE */}
      <img
        src={`${process.env.PUBLIC_URL}/MapaMiraflores.png`}
        alt="Mapa de Miraflores con ruta activa"
        className="w-full h-full object-cover"
      />

      {/* CITY LABEL */}
      <div className="absolute left-3 top-3 flex items-center gap-1.5 rounded-lg bg-white/90 px-2.5 py-1.5 shadow text-xs font-semibold">
        <MapPin className="size-3" style={{ color: brand.primary }} />
        Miraflores
      </div>

      {/* ETA LABEL */}
      <div className="absolute right-3 bottom-3 flex items-center gap-1.5 rounded-lg bg-white/90 px-2.5 py-1.5 shadow text-xs">
        <Clock className="size-3" />
        ETA 12 min
      </div>

      {/* DELIVERY ROUTE OVERLAY */}
      <svg
        className="pointer-events-none absolute inset-0"
        viewBox="0 0 800 480"
        preserveAspectRatio="none"
      >
        <motion.path
          d="M80,360 C180,320 260,300 360,260 C520,200 620,180 700,140"
          fill="none"
          stroke={brand.primary}
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeDasharray="8 10"
          vectorEffect="non-scaling-stroke"
          initial={{ pathLength: 0, opacity: 1 }}
          animate={{ pathLength: [0, 1, 1, 0], opacity: [1, 1, 0.6, 0] }}
          transition={{
            duration: 1.6,
            ease: "easeInOut",
            times: [0, 0.7, 0.85, 1],
            repeat: Infinity,
            repeatType: "loop",
            repeatDelay: 2
          }}
        />

        {/* DESTINATION MARKER */}
        <g transform="translate(700,140)">
          <circle r="14" fill={brand.accentGreen} />
          <circle r="20" fill="white" opacity="0.9" />
          <circle r="14" fill={brand.accentGreen} />
        </g>

        {/* DRIVER MARKER */}
        <g transform="translate(80,360)">
          <circle r="16" fill={brand.primary} opacity="0.25">
            <animate
              attributeName="r"
              values="16;22;16"
              dur="1.8s"
              repeatCount="indefinite"
            />
          </circle>
          <circle r="12" fill={brand.primary} />
        </g>
      </svg>

    </div>
  );
}